import { DocumentCitizenshipFormVM } from 'civil-status/view-models/document-citizenship-form';
import { PageMode } from 'civil-status/view-models/page-mode';
import { FormikErrors, FormikTouched } from 'formik';
import PmiTextField from 'shell/components/shared/text-field';
import ListGender from 'shell/components/shared/gender';
import { DatePicker } from '@mui/lab';
import MatricolaList from './matricola-list';
import { memo, useMemo } from 'react';
import { Grid } from '@mui/material';

interface DocumentUnionForm {
  values?: DocumentCitizenshipFormVM;
  errors?: FormikErrors<DocumentCitizenshipFormVM>;
  touched?: FormikTouched<DocumentCitizenshipFormVM>;
  onChange: (
    key: keyof DocumentCitizenshipFormVM,
    value: DocumentCitizenshipFormVM[keyof DocumentCitizenshipFormVM]
  ) => void;
  onChanges: (values: DocumentCitizenshipFormVM) => void;
  mode: PageMode;
}
const CitizenshipForm = ({
  values,
  touched,
  errors,
  mode,
  onChange,
  onChanges,
}: DocumentUnionForm) => {
  const disabled = useMemo(() => {
    return mode === PageMode.Detail;
  }, [mode]);

  return (
    <>
      <Grid item container xs={12} spacing={2} style={{ paddingTop: '0px' }}>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <MatricolaList
            isSmallSize
            aria-label="Matricola"
            label="Matricola"
            id="matricola"
            surname={values?.surname || ''}
            name={values?.name || ''}
            dateBirth={values?.birthday || null}
            disabled={disabled}
            value={values?.matricola || ''}
            onChanges={(value) => onChanges(value)}
            error={touched?.matricola && Boolean(errors?.matricola)}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Cognome"
            label="Cognome"
            id="surname"
            name="surname"
            fullWidth
            disabled
            value={values?.surname || ''}
            onChange={(event) => onChange('surname', event?.target.value)}
            error={touched?.surname && Boolean(errors?.surname)}
            helperText={errors?.surname}
            inputProps={{
              maxLength: '155',
            }}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Nome"
            label="Nome"
            id="name"
            name="name"
            fullWidth
            disabled
            value={values?.name || ''}
            onChange={(event) => onChange('name', event?.target.value)}
            error={touched?.name && Boolean(errors?.name)}
            helperText={errors?.name}
          />
        </Grid>
        <Grid item xs={12} md={6} style={{ paddingTop: '10px' }}>
          <ListGender
            isSmallSize
            value={values?.gender || ''}
            onChange={(event) => onChange('gender', event?.target.value)}
            error={touched?.gender && Boolean(errors?.gender)}
            disabled={disabled}
          />
        </Grid>
        <Grid item xs={12} md={6} style={{ paddingTop: '10px' }}>
          <DatePicker
            label="Data nascita"
            aria-label="Data nascita"
            value={values?.birthday || null}
            disabled={disabled}
            onChange={(value) => onChange('birthday', value)}
            renderInput={(params) => (
              <PmiTextField
                id="birthday"
                name="birthday"
                {...params}
                fullWidth
                error={touched?.birthday && Boolean(errors?.birthday)}
                helperText={errors?.birthday}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '0px' }}>
          <span>F2 per Milano</span>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Comune nascita"
            label="Comune nascita"
            id="birthdayMunicipality"
            name="birthdayMunicipality"
            onChange={(event) => onChange('birthdayMunicipality', event?.target.value)}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('birthdayMunicipality', 'MILANO');
                return;
              }
            }}
            value={values?.birthdayMunicipality || ''}
            helperText={errors?.birthdayMunicipality}
            error={touched?.birthdayMunicipality && Boolean(errors?.birthdayMunicipality)}
            fullWidth
            disabled={disabled}
            inputProps={{
              maxLength: '155',
            }}
          />
          <span>F2 per Milano</span>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <PmiTextField
            aria-label="Comune residenza"
            label="Comune residenza"
            id="residenceMunicipality"
            name="residenceMunicipality"
            onChange={(event) => onChange('residenceMunicipality', event?.target.value)}
            onKeyDown={(event) => {
              if (event.code === 'F2') {
                event.preventDefault();
                event.stopPropagation();
                onChange('residenceMunicipality', 'MILANO');
                return;
              }
            }}
            value={values?.residenceMunicipality || ''}
            helperText={errors?.residenceMunicipality}
            error={touched?.residenceMunicipality && Boolean(errors?.residenceMunicipality)}
            fullWidth
            disabled={disabled}
            inputProps={{
              maxLength: '155',
            }}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: '10px' }}>
          <DatePicker
            label="Data cittadinanza"
            aria-label="Data cittadinanza"
            value={values?.citizenshipDate || null}
            disabled={disabled}
            onChange={(value) => onChange('citizenshipDate', value)}
            renderInput={(params) => (
              <PmiTextField
                id="citizenshipDate"
                name="citizenshipDate"
                {...params}
                fullWidth
                error={touched?.citizenshipDate && Boolean(errors?.citizenshipDate)}
                helperText={errors?.citizenshipDate}
              />
            )}
          />
        </Grid>
      </Grid>
    </>
  );
};

CitizenshipForm.displayName = 'Document Citizenship form component';

const CitizenshipFormComponent = memo(CitizenshipForm);

export default CitizenshipFormComponent;
